import { getAsyncContextStrategy as c } from "./chunk882.js";
import { getMainCarrier as n } from "./chunk883.js";
function a() {
  const t = n();
  return c(t).getCurrentScope();
}
function u() {
  const t = n();
  return c(t).getIsolationScope();
}
function g(...t) {
  const e = n(), r = c(e);
  if (t.length === 2) {
    const [o, i] = t;
    return o ? r.withSetScope(o, i) : r.withScope(i);
  }
  return r.withScope(t[0]);
}
function S() {
  return a().getClient();
}
export {
  S as getClient,
  a as getCurrentScope,
  u as getIsolationScope,
  g as withScope
};
